import { render, staticRenderFns } from "./coTransferHistory.vue?vue&type=template&id=c70bdf38&scoped=true"
import script from "./coTransferHistory.vue?vue&type=script&lang=js"
export * from "./coTransferHistory.vue?vue&type=script&lang=js"
import style0 from "./coTransferHistory.vue?vue&type=style&index=0&id=c70bdf38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70bdf38",
  null
  
)

export default component.exports